<button
  type="button"
  class="scroll-top-btn"
  [class.visible]="visible"
  (click)="scroll()"
  [attr.aria-label]="atTop ? 'Scroll to bottom' : 'Scroll to top'">
  <i class="fa" [ngClass]="atTop ? 'fa-angle-down' : 'fa-angle-up'"></i>
</button>
